import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MESSAGE_FORMAT_CONFIG, TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

import { DEFAULT_I18N_CONFIG, DEFAULT_I18N_CONFIG_TOKEN, NEW_I18N_CONFIG_TOKEN, SntI18nModuleConfig } from './config';
import { PruneTranslateLoader } from './prune-translate-loader';
import { getLangsConsiderConfig } from './i18n.service';
import { SntLocaleProvider } from './locale.provider';

export const translateModuleConfig = {
  compiler: {
    provide: TranslateCompiler,
    useClass: TranslateMessageFormatCompiler,
  },
  useDefaultLang: true,
};

function _configFactory(
  defaultCfg: SntI18nModuleConfig,
  config: SntI18nModuleConfig | (() => SntI18nModuleConfig),
): (() => SntI18nModuleConfig) | SntI18nModuleConfig {
  return typeof config === 'function' ? config() : { ...defaultCfg, ...config };
}

function _translateLoaderFactory(http: HttpClient, config: SntI18nModuleConfig) {
  return new PruneTranslateLoader(http, config);
}

function _messageFormatConfigFactory(config: SntI18nModuleConfig) {
  return { locales: Array.from(getLangsConsiderConfig(config).keys()) };
}

@NgModule({
  imports: [TranslateModule.forRoot(translateModuleConfig)],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class SntI18nModule {
  static forRoot(config?: SntI18nModuleConfig): ModuleWithProviders<SntI18nModule> {
    return {
      ngModule: SntI18nModule,
      providers: [
        {
          provide: NEW_I18N_CONFIG_TOKEN,
          useValue: config,
        },
        {
          provide: DEFAULT_I18N_CONFIG_TOKEN,
          useValue: DEFAULT_I18N_CONFIG,
        },
        {
          provide: SntI18nModuleConfig,
          useFactory: _configFactory,
          deps: [DEFAULT_I18N_CONFIG_TOKEN, NEW_I18N_CONFIG_TOKEN],
        },
        {
          provide: TranslateLoader,
          useFactory: _translateLoaderFactory,
          deps: [HttpClient, SntI18nModuleConfig],
        },
        {
          provide: MESSAGE_FORMAT_CONFIG,
          useFactory: _messageFormatConfigFactory,
          deps: [SntI18nModuleConfig],
        },
        SntLocaleProvider,
      ],
    };
  }
}
